import React from 'react';
import {useNavigate, Outlet} from 'react-router-dom';
import './authWrapper.scss';
import {Button} from 'components';
import LOGO from 'assets/sbaj_logo.png';
import BUSINESS_LADY_IMAGE from 'assets/registration/login_image.png';

const AuthWrapper: React.FC = () => {
    const navigate = useNavigate()
    return (
        <div className={'auth-wrapper'}>
            <div className="auth-wrapper_left">
                <div className="auth-wrapper_left_container">
                    <img className={'auth-wrapper_left_container_main-image'} src={BUSINESS_LADY_IMAGE} alt=""/>
                </div>
            </div>
            <div className="auth-wrapper_right">
                <div className="auth-wrapper_right_top">
                    <Button text={'Home'} type={'primary'} onclick={() => navigate("/")}/>
                </div>
                <div className="auth-wrapper_right_bottom">
                    <div className="auth-wrapper_right_bottom_logo" onClick={() => navigate("/")}>
                        <img src={LOGO} alt=""/>
                    </div>
                    <Outlet/>
                </div>
            </div>
        </div>
    );
};

export default AuthWrapper;
